module.exports = __webpack_public_path__ + "img/japan-external-causes-female.158ddc41.png";